/** Build-time feature flags read from NEXT_PUBLIC_* env vars. */

function getBooleanEnv(name: string, defaultValue: boolean): boolean {
  const value = process.env[name]
  if (value === undefined) return defaultValue
  return value === 'true'
}

/**
 * When true, anonymous (signed-out) users are blocked from running a search:
 * search buttons/inputs open the sign-in/sign-up modal instead of searching,
 * and the /search page shows the same modal instead of calling the API.
 * Mirrors the backend's `require_auth_for_search` setting — keep both in
 * sync when toggling this in an environment, otherwise a signed-out user who
 * gets past the frontend gate (e.g. a stale bookmark) will just see a 401
 * banner instead of the intended sign-in prompt (or vice versa).
 */
export const REQUIRE_AUTH_FOR_SEARCH = getBooleanEnv(
  'NEXT_PUBLIC_REQUIRE_AUTH_FOR_SEARCH',
  true,
)

/**
 * When true, Penthouse paywalls are enforced in the UI (upgrade prompts,
 * locked features, free-tier roostr limits). When false, the product runs
 * in temporary free mode — `isPenthouse` / `canUseFeature` / `maxRoostrs`
 * all unlock as if the user had an active Penthouse plan.
 *
 * Mirrors the backend's `subscription_gating_enabled` setting — keep both
 * in sync. Defaults to false (free promo). Set
 * `NEXT_PUBLIC_SUBSCRIPTION_GATING_ENABLED=true` to re-enable payments.
 */
export const SUBSCRIPTION_GATING_ENABLED = getBooleanEnv(
  'NEXT_PUBLIC_SUBSCRIPTION_GATING_ENABLED',
  false,
)
